<template>
    <div  style="border-bottom: 1px solid rgb(204, 204, 204); padding-bottom: 4px;">
        <router-link to="/import/errors" class="import-link" tag="button" :disabled="importErrors.length == 0">
            <ImportErrorIcon class="error" ></ImportErrorIcon>
            Import Errors ({{importErrors.length}})
            <span class="spinner">
                <LoadSpinner v-if="loadingImportErrors" type="primary" />
            </span>
        </router-link>
    </div>
</template>

<script>
import { mapState } from "vuex"
import ImportErrorIcon from './ImportErrorIcon'
import LoadSpinner from '@/module/component/icon/LoadSpinner.vue'

export default {
	name: 'import-errors',
	components: {
		ImportErrorIcon,
        LoadSpinner
    },
    computed: {
        ...mapState('provider', [
            'importErrors',
            'loadingImportErrors'
        ])
    }
}
</script>

<style lang="scss">

button.import-link {
    background-color: transparent;
    color: #333333;
    font-weight: bold;
    height: 33px;
    line-height: 33px;
    width: 100%;
    font-size: 13px;
    margin: 0px;
    text-decoration: none;
    display: flex;
    padding: 0px 10px;
    border: none;
    color: #666;
    text-align: left;

    svg.error  {
        margin: 10px 11px 4px 4px;
        .svg-circle {
            fill: #e87318;
        }
        path {
            fill: #fff;
        }
    }
    .spinner {
        flex-grow: 1;
        display: inline-block;
        margin-top: 2px;
        text-align: right;
        svg {
            width: 12px;
            
        }
    }
    &:hover {
        background-color: #e2e2e2;
    }
    &:disabled {
        cursor: not-allowed;
        background-color: #f8f8f8;
        font-weight: 300;
        color: #666;
    }
    &.router-link-active {
        background-color: #3572b9;
        color: #fff;
        svg {
            .svg-circle {
                fill: #fff;
            }
            path {
                fill: #3572B9;
            }
        }
    }

}
</style>
